
import { observable, action, runInAction, configure, makeObservable } from "mobx";
import { ApiBasePath } from "../../utils/ApiBasePath";
import * as Request from "superagent";
import ServiceDetailsModel from "./models/ServiceDetailsModel";
import ServiceIntervalsModel from "./models/ServiceIntervalsModel";
import OperationDetailsModel from "./models/OperationDetailsModel";

configure({ enforceActions: "always" });

export default class ServiceDetailsStore {
  constructor() {
    makeObservable(this);
  }
  @action resetDetails = () => {
    this.vehicleMetadata.reset();
    this.serviceIntervals.reset();
    this.operationDetails.reset();
  }

  @observable serviceIntervals?: ServiceIntervalsModel = new ServiceIntervalsModel(this.resetDetails);
  @observable operationDetails?: OperationDetailsModel = new OperationDetailsModel(this.resetDetails);
  @observable vehicleMetadata?: ServiceDetailsModel = new ServiceDetailsModel(this.serviceIntervals, this.resetDetails);
}
